<template>
    <select>
        <slot></slot>
    </select>
</template>

<script>
import Select2 from "select2";

export default {
  props: ["options", "value", "width", "placeholder"],

  mounted: function() {
    var vm = this;
    $(this.$el)
      // init select2
      .select2({
        data: this.options,
        placeholder: this.placeholder,
        dropdownAutoWidth: true,
        width: this.width,
        allowClear: true
      })
      .val(this.value)
      .trigger("change")
      // emit event on change.
      .on("change", function() {
        vm.$emit("input", this.value);
      });
  },
  watch: {
    value: function(value) {
      // update value
      $(this.$el)
        .val(value)
        .trigger("change");
      this.$emit("input", value);
    },
    options: function(options) {
      // update options
      $(this.$el)
        .empty()
        .select2({ data: options });
    }
  },
  destroyed: function() {
    $(this.$el)
      .off()
      .select2("destroy");
  }
};
</script>
<style src="select2/dist/css/select2.css"></style>
<style>
.select2-container--default
  .select2-results__option{
    margin:5px;

}

.select2-container--default
  .select2-results__option--highlighted[aria-selected] {
      background-color: #3ea535d2;
      border-radius: 4px;
      box-shadow: 3px 3px 1px #62b55c69;
      border: 1px solid #00800045;


}
.select2-container--default .select2-search--dropdown .select2-search__field {
  outline-color: #43bd38;

}
.select2-container--default
  .select2-selection--single
  .select2-selection__rendered {
  outline-color: 0;
  border-color: red;

}
.select2-container--default .select2-selection--single {
  outline-color: #43bd38;
}

.select2-hidden-accessible {
  display: none;
}

.akg-table-select .select2-hidden-accessible {
  display: none;
}
.select2-dropdown.select2-dropdown--below {
    border-color: white;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/Select2.vue